<template>
  <AuthBox>
    <h1 class="auth-title mb-6">Sign up to DinoTrack</h1>
    <div class="d-flex justify-center">
      <span class="your-role-is-teacher mb-6">Your role is <strong>Teacher</strong></span>
    </div>
    <div class="d-flex justify-center">
      <svg-icon icon="teacher_signup" class="mb-6" width="250" height="100" />
    </div>
    <div class="d-flex justify-center">
      <v-btn color="primary btn-primary-custom" :to="{ name: 'AuthRegisterTeacherForm' }" style="text-decoration: none;">
        <svg-icon icon="signup" class="mr-5" left />Sign up with email</v-btn
      >
    </div>
    <v-divider class="mt-6 mb-6" />
    <div class="d-flex justify-center">
      <GoogleLoginButton :clientId="clientId" @success="onSuccess" @failure="onFailure" />
    </div>
    <span class="d-flex justify-center mt-6 dont-have-an-accoun">
      {{ $t('content.signin_1') }}
      <router-link :to="{ name: 'AuthLogin' }" style="text-decoration: none;">
        {{ $t('content.signin') }}
      </router-link></span
    >
  </AuthBox>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { hasNumber, hasSpecialChar, hasUppercase } from '@/validators/shared';
import { decodeJwt } from '@/helper/jwt';
import GoogleLoginButton from '@/components/base/GoogleLoginButton.vue';
import AuthBox from '@/components/base/AuthBox';

export default {
  name: 'AuthChangePassword',
  components: {
    AuthBox,
    GoogleLoginButton
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user'
    })
  },
  layout: 'empty',
  validations: {
    form: {
      pass1: { required, minLength: minLength(6), hasNumber, hasUppercase, hasSpecialChar },
      pass2: { required, sameAsPassword: sameAs('pass1') }
    }
  },
  data: () => ({
    form: {
      pass1: '',
      pass2: ''
    },
    loading: false,
    showPassword: false,
    showPassword2: false,
    client_id: process.env.VUE_APP_OAUTH
  }),
  methods: {
    onSuccess(credential) {
      const user = decodeJwt(credential);
      this.loading = true;
      this.$store
        .dispatch(`Auth/loginGoogle`, user.sub)
        .then(({ roleId, verified, student, classroomStatus, classroomStatusDetail, cerdasTypeId }) => {
          if (roleId === 1 && verified) {
            this.$router.push({ name: 'ReportAdminIndex' });
          } else if (roleId === 2 && verified) {
            this.$router.push({ name: 'MasterUserSchool' });
          } else if (roleId === 6 && verified) {
            this.$router.push({ name: 'StudentIndex' });
          } else if (roleId === 3 && verified && student == true && classroomStatus == true) {
            this.$router.push({ name: 'ChildList' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == true && classroomStatusDetail == true) {
            this.$router.push({ name: 'ParentClassIndex' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == true && classroomStatusDetail == false) {
            this.$router.push({ name: 'ChildList' });
          } else if (roleId === 3 && verified && student == false && classroomStatus == false) {
            this.$router.push({ name: 'ParentClassIndex' });
          } else if (roleId === 4 && verified && cerdasTypeId === 1) {
            this.$router.push({ name: 'CourseIndex' });
          } else if (roleId === 4 && verified && cerdasTypeId === 2) {
            this.$router.push({ name: 'TeacherClassIndex' });
          } else if (roleId === 5 && verified) {
            this.$router.push({ name: 'StudentClassIndex' });
          } else if (roleId && !verified) {
            this.$router.push({ name: 'AuthChangePassword' });
          }
          localStorage.setItem('notif', 0);
        })
        .catch(err => {
          const code = err?.response?.data?.errorMessages;
          if (code === 'Google account not registered') {
            let user = decodeJwt(credential);
            let value = { pu: user.email, xV: user.name, sT: user.family_name, registrationToken: user.sub };
            this.$store.dispatch('Auth/setAuth', value).then(() => this.$router.push({ name: 'AuthRegisterTeacherForm' }));
          }
        })
        .finally(() => {
          this.loading = false;
          // setTimeout(() => this.$router.go(), 100);
        });
    },
    onFailure() {
      console.log('test');
    }
  },
  created() {
    this.$store.commit('Auth/SET_GOOGLE_AUTH_CLEAR');
  }
};
</script>

<style lang="scss" scoped>
.dont-have-an-accoun {
  color: #acacac;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.forgot {
  color: #ce8800;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.your-role-is-teacher {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
